// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"498b0f73","160":"5511ef69","208":"661f23de","293":"df265969","488":"9d97ac5d","516":"0428d971","519":"839a0131","917":"5fbcfcea","946":"4b7f0c7e"}[chunkId] + ".chunk.js";
};